import PropTypes from 'prop-types';
import React from 'react';
import * as _ from 'lodash';
import MapIcon from '@fabric-ds/icons/dist/16/map.svg';

const AdAdress = ({ link, streetAddress, postNumber, postArea }) => {
    if (link) {
        return (
            <a className="text-16 text-blue-600 mt-8 flex items-center" href="#beliggenhet">
                <MapIcon alt="Beliggenhet ikon" />
                <p className="pl-4 mb-0">
                    {streetAddress !== '' && streetAddress != null && `${streetAddress}, `}
                    {postNumber} {!_.isEmpty(postArea) && postArea}
                </p>
            </a>
        );
    }
    return (
        <>
            {streetAddress !== '' && streetAddress !== null && (
                <p className="gray-700 inline-block" aria-label="Adresse">
                    {`${streetAddress},\xa0`}
                </p>
            )}
            {postNumber && (
                <p className="gray-700 inline-block" aria-label="Postnummer">
                    {postNumber}
                </p>
            )}
            {!_.isEmpty(postArea) && (
                <p className="gray-700 inline-block" aria-label="By">
                    , {postArea}
                </p>
            )}
        </>
    );
};

AdAdress.propTypes = {
    link: PropTypes.bool,
    streetAddress: PropTypes.string,
    postNumber: PropTypes.string,
    postArea: PropTypes.string,
};

export default AdAdress;
